<section class="auth-section">
  <div class="container">
    <div class="login-box login-box-sm">
      <h2 class="mb-4">
        <h2 class="card-title">
          <a (click)="goBack()" href="javascript:void(0)"
            ><i class="fa fa-long-arrow-left"></i
          ></a>
        </h2>
        Help & Support
      </h2>
      <div class="text-center mb-4">
        <img src="assets/img/help-page-icon.png" />
      </div>
      <form class="form-w" [formGroup]="helpForm">
        
        <div class="form-group">
          <label>Name</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Your Name"
            formControlName="name"
            [ngClass]="{
              'is-invalid':
                (submitted || (f.name.touched && !f.name.valid)) &&
                f.name.errors
            }"
          />
          <div
            *ngIf="(submitted || f.name.touched) && f.name.errors"
            class="invalid-feedback"
          >
            <!-- Priority 1: Show whitespace error IF it exists -->
            <div *ngIf="f.name.errors.whitespace">
              Name cannot be just whitespace
            </div>
            <!-- Priority 2: ONLY show required error IF whitespace error is NOT present -->
            <div *ngIf="!f.name.errors.whitespace && f.name.errors.required">
              Name is required
            </div>
          </div>
        </div>

       
        <div class="form-group">
          <label>Email</label>
          <input
            type="text"
            class="form-control"
            placeholder="Enter Your Email"
            formControlName="email"
            [ngClass]="{
              'is-invalid':
                (submitted || (f.email.touched && !f.email.valid)) &&
                f.email.errors
            }"
          />
          <div
            *ngIf="(submitted || f.email.touched) && f.email.errors"
            class="invalid-feedback"
          >
            <!-- Priority 1: Required error -->
            <div *ngIf="f.email.errors.required">Email is required</div>

            <!-- Priority 2: Standard email format error (only shows if 'required' is false) -->
            <div *ngIf="!f.email.errors.required && f.email.errors.email">
              Email must be a valid email address (e.g., user@domain.com)
            </div>

            <!-- Priority 3: Strict pattern error (only shows if 'required' and 'email' errors are false) -->
            <div
              *ngIf="
                !f.email.errors.required &&
                !f.email.errors.email &&
                f.email.errors.pattern
              "
            >
              Email must be a proper format (e.g., user@domain.com)
            </div>
          </div>
        </div>






        <div class="form-group">
          <label>Mobile</label>
          <input
            (keypress)="cmnFunction.keyPress($event)"
            appPhoneMask
            type="text"
            class="form-control"
            placeholder="(XXX) XXX-XXXX"
            formControlName="mobileNumber"
            maxlength="14"
            [ngClass]="{
              'is-invalid': (submitted || f.mobileNumber.touched) && f.mobileNumber.errors
            }"
          />
          <div *ngIf="(submitted || f.mobileNumber.touched) && f.mobileNumber.errors" class="invalid-feedback">
            <div *ngIf="f.mobileNumber.errors.required">
              Mobile Number is required
            </div>
     
            <div *ngIf="f.mobileNumber.errors.minlength">
              Enter a valid 10-digit Mobile number
            </div>
          </div>
        </div>





        <div class="form-group">
          <label>Type of Inquiry</label>
          <select
            class="form-control"
            formControlName="type"
            [ngClass]="{
              'is-invalid':
                (submitted || (f.type.touched && !f.type.valid)) &&
                f.type.errors
            }"
          >
            <option value="" disabled>Type of Inquiry</option>
            <ng-container *ngFor="let ti of inquryTypes">
              <option value="{{ ti.type }}">{{ ti.type }}</option>
            </ng-container>
          </select>
          <div
            *ngIf="(submitted || f.type.touched) && f.type.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.type.errors.required">Type is required</div>
          </div>
        </div>
        <!-- <div class="form-group">
          <label>Message</label>
          <textarea
            class="form-control"
            placeholder="Type Message"
            style="resize: none"
            formControlName="message"
            [ngClass]="{
              'is-invalid':
                (submitted || (f.message.touched && !f.message.valid)) &&
                f.message.errors
            }"
          >
          </textarea>
          <div
            *ngIf="(submitted || f.message.touched) && f.message.errors"
            class="invalid-feedback"
          >
            <div *ngIf="f.message.errors.required">Message is required</div>
          </div>
        </div> -->

        <div class="form-group">
          <label>Message</label>
          <textarea
            class="form-control"
            placeholder="Type Message"
            style="resize: none"
            formControlName="message"
            [ngClass]="{
              'is-invalid':
                (submitted || (f.message.touched && !f.message.valid)) &&
                f.message.errors
            }"
          >
          </textarea>
          <div
            *ngIf="(submitted || f.message.touched) && f.message.errors"
            class="invalid-feedback"
          >
            <!-- Priority 1: Show whitespace error IF it exists -->
            <div *ngIf="f.message.errors.whitespace">
              Message cannot be just whitespace
            </div>
            <!-- Priority 2: ONLY show required error IF whitespace error is NOT present -->
            <div
              *ngIf="!f.message.errors.whitespace && f.message.errors.required"
            >
              Message is required
            </div>
          </div>
        </div>

        <div class="form-group">
          <button
            class="btn btn-primary btn-block my-2 btn-lg"
            [disabled]="isLoadingData"
            (click)="submitHelp()"
          >
            <span
              *ngIf="isLoadingData"
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Submit
          </button>
        </div>
        <div class="help-footer-link">
          <div class="row">
            <!-- <div class="col-sm-6 text-center border-right">
                            <p class="my-1"><img src="assets/img/help-call-icon.png" class="mr-2"> Call Us : <a class="text-inherit" href="tel:+1 404 795 4529">+1 404 795 4529</a></p>
                        </div> -->
            <div class="col-sm-12 text-center">
              <p class="my-1">
                <img src="assets/img/help-mail-icon.png" class="mr-2" /> Write
                Us :
                <a
                  class="text-inherit"
                  href="mailto:customerservice@wooffertechnologies.com"
                  >customerservice@wooffertechnologies.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</section>
